module.exports = __webpack_public_path__ + "static/media/me.92b2f677.jpg";